import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Options } from 'tabulator-tables';
import { isEmpty, forEach, isArray, find } from 'lodash';

import {
  TransformationService,
  TabulatorService,
  DialogService,
  Site,
  ActiveTestQueuedStateService,
  Device,
  IDeviceData
} from '@nrwl/common-lib';
import { ViaviTableComponent } from '@nrwl/viavi-tabulator';
import { MonitorsService } from '@nrwl/monitor-management';

import { MultipickerService } from '../../service/multipicker.service';

@Component({
  selector: 'nrwl-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.scss']
})
export class DeviceTableComponent implements OnInit {
  @ViewChild(ViaviTableComponent) deviceTable: ViaviTableComponent;
  //eslint-disable-next-line
  @Input() devices: any;
  //eslint-disable-next-line
  @Input() selectedDevices: any;
  //eslint-disable-next-line
  @Input() hidingData: any;
  //eslint-disable-next-line
  @Input() siteList: any;
  //eslint-disable-next-line
  @Input() siteComp: any;
  //eslint-disable-next-line
  @Input() hidingDeviceData: any;
  @Input() singleSelection: boolean;
  @Input() testType: string;
  @Input() hideResourceUnavailableAgent: boolean;
  table: Options;
  dataSourceNameImg = 'images/agents-bp.svg';
  platform = 'platform';
  monitorCountResponse: { activeMonitorsCount: number; monitorMaxLimit: number };
  constructor(
    private transformService: TransformationService,
    private tabulatorService: TabulatorService,
    private multipickerService: MultipickerService,
    private monitorsService: MonitorsService,
    private dialogService: DialogService,
    private activeTestQueuedStateService: ActiveTestQueuedStateService
  ) {
    this.table = this.tabulatorService.commonTableConfiguration();
    this.table.persistenceID = 'multi-device-selection';
    this.table.groupHeader = this.tabulatorService.groupHeader;
  }
  ngOnInit(): void {
    if (this.hidingDeviceData) {
      this.devices = this.devices.filter(item => item.id !== this.hidingDeviceData.id);
    }
    if (this.hidingData) {
      if (this.hidingData.itemType !== 'device') {
        this.devices = this.devices.filter(item => item?.site !== this.hidingData.site.id);
      }
    }

    this.assignData();
  }
  // eslint-disable-next-line
  assignData(): void {
    const currentDataSource = this.transformResponse(this.devices);
    if (this.selectedDevices && this.selectedDevices.length > 0) {
      const result = currentDataSource.map(el => {
        if (this.selectedDevices.find(filteredId => el.id === filteredId.id)) {
          el.isChecked = true;
        }
        return el;
      });
      this.devices = result;
    } else {
      this.devices = currentDataSource;
    }
    if (this.hideResourceUnavailableAgent) {
      this.devices = this.devices.filter(device => !device.warningMessage);
    }

    const statusOrder = ['online', '', 'offline', 'unregistered', 'disabled'];
    this.devices = this.devices.sort(function (a, b) {
      return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
    });
    const transformedData = this.transformService.transformData('device-dropdown', this.devices);
    this.table.height = 500;
    delete this.table.rowHeight;
    if (this.singleSelection) {
      delete this.table.selectable;
      delete this.table.selectableRangeMode;
    }
    this.table.columns = transformedData.column;
    this.table.data = transformedData.data;
    if (this.table.persistence) {
      this.table.persistence.sort = true;
      this.table.persistence.page = true;
    }
    if (this.singleSelection) {
      this.table.hideSelectAll = true;
    }
    this.table = Object.assign({}, this.table);
  }
  sendSelectedItem(event: { type: string }): void {
    if (this.singleSelection) {
      if (this.siteComp && this.siteComp?.siteTable?.table?.deselectRow)
        this.siteComp.siteTable.table.deselectRow();
      const oldRowSelection = Object.assign([], this.deviceTable.table.getSelectedData());
      if (oldRowSelection.length > 1) {
        const x = oldRowSelection[0];
        this.deviceTable.table.deselectRow(x.id);
      }
    }
    const actualTest =
      this.monitorsService.monitorCountResponse?.success.monitorMaxLimit -
      this.monitorsService.monitorCountResponse?.success.activeMonitorsCount;
    if (
      this.deviceTable?.selection?.length + this.multipickerService.selectedSites.length >
      this.multipickerService.TEST_LIMIT_COUNT
    ) {
      this.deselectRows(event);
      this.multipickerService.showBulkTestLimitDialog();
    } else if (
      this.deviceTable?.selection?.length + this.multipickerService.selectedSites.length >
      actualTest
    ) {
      const testInfo = {
        maxLimit: this.monitorsService.monitorCountResponse.success.monitorMaxLimit,
        activeCount: this.monitorsService.monitorCountResponse.success.activeMonitorsCount
      };
      const warningMsg = this.monitorsService.getWarningMessage(testInfo);
      this.deselectRows(event);
      this.multipickerService.showTestLimitDialog(warningMsg);
    } else {
      this.multipickerService.selectedDevices = this.deviceTable.selection;
    }
  }
  //eslint-disable-next-line
  transformResponse(deviceData: Array<Device>): any[] {
    const tranformedData = [];
    if (!isEmpty(deviceData) && isArray(deviceData)) {
      forEach(deviceData, (item: IDeviceData) => {
        // eslint-disable-next-line
        const result: any = {};
        switch (item.type) {
          case 'GigaTestAgent':
            result.id = item.id;
            result.name = this.getIconLabelName(item.name, this.dataSourceNameImg);
            result.type = this.transformService.getPlatformIconInfo(
              this.getParamsValueByName(item.params, this.platform),
              item.tenantId,
              item.agentType
            );
            result.site = this.getSiteLocationById(item.site?.toString());
            result.dataType = item.type;
            result.status = item.status;
            result.state = item.state;
            result.dataItem = item;
            result.testAssigned = this.multipickerService.getTestAssignedDatasource(
              this.multipickerService.getActiveTestQueuedStatus(
                this.activeTestQueuedStateService.getDevicesWithTests(),
                item.id
              ),
              item.name
            );
            result.warningMessage = this.multipickerService.getWarningMessage(
              null,
              item.id,
              item.status,
              this.testType
            );
            break;
          case 'unmanaged':
            result.id = item.id;
            result.name = { label: item.name };
            result.site = this.getSiteLocationById(item.site?.toString());
            result.dataType = item.type;
            result.status = item.status ?? '';
            result.state = item.state;
            result.dataItem = item;
            result.type = { label: 'Unmanaged' };
        }
        tranformedData.push(result);
      });
    }
    return tranformedData;
  }
  getIconLabelName(labelName: string, iconName: string): { icon: string; label: string } {
    return {
      icon: iconName,
      label: labelName
    };
  }
  //eslint-disable-next-line
  getSiteLocationById(siteId: string): { label: string; sublabel: ''; location: any } {
    const siteObj: Site = this.getSitesById(siteId);
    //eslint-disable-next-line
    const sitesInfo: any = {
      id: '',
      label: '',
      sublabel: 'Site not defined',
      location: {}
    };
    if (siteObj) {
      sitesInfo.id = siteObj.getId();
      sitesInfo.label = siteObj.getName();
      sitesInfo.sublabel = siteObj.getLocationName();
      sitesInfo.location = siteObj.getLocation();
    }
    return sitesInfo;
  }
  getSitesById(siteId: string): Site {
    return this.siteList.find(site => site.getId().toString() === siteId);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getParamsValueByName(params: any, name: string): any {
    const paramsObj = find(params, ['name', name]);
    return paramsObj && paramsObj.value ? paramsObj.value : '';
  }
  // eslint-disable-next-line
  deselectRows(event: any): void {
    if (event.type === 'multiple') {
      this.deviceTable.table.deselectRow();
    } else {
      const oldRowSelection = Object.assign([], this.deviceTable.table.getSelectedData());
      const x = oldRowSelection.pop();
      this.deviceTable.table.deselectRow(x.id);
    }
  }
}
